import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import CreateOutlinedIcon from "@material-ui/icons/CreateOutlined";
import { Autocomplete, Skeleton } from "@material-ui/lab";
import { useQuery } from "@tanstack/react-query";
import { fetchInstitutos } from "../../../../shared/fetchers/classics/institutos/verInstitutos";
import { TextField } from "@material-ui/core";
import CrearInstitutoClassicsIndividual from "../../adicionar-elementos/crear-instituto/crear-instituto-individual";

const EditarInstitutoClassics = () => {
  const [instituto, setInstituto] = useState(null);
  const [editDone, setEditDone] = useState(false);

  const {
    data: institutos,
    isLoading,
    isError,
  } = useQuery(["institutosClassics"], fetchInstitutos);

  useEffect(() => {
    if (editDone) {
      setInstituto(null);
      setEditDone(false);
    }
  }, [editDone]);

  if (isLoading)
    return (
      <>
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
      </>
    );

  if (isError)
    return <div>Ha ocurrido un error, prueba recargando la página</div>;

  return (
    <>
      <div className="mb-4 d-flex align-items-center">
        <div className="admin-page-tilte">(</div>
        <CreateOutlinedIcon />
        <div className="admin-page-tilte mr-2">)</div>
        <div className="admin-page-tilte">Editar Instituto</div>
      </div>
      <Container fluid>
        <Row>
          <Col xs={12} className="content-white-box px-4 py-4">
            <label className="admin-label-text mt-3 d-block">
              Selecciona un instituto para editarlo:
            </label>
            <Autocomplete
              options={institutos}
              value={instituto}
              disabled={Boolean(instituto)}
              getOptionLabel={(option) => option.nombre}
              onChange={(_, newValue) => {
                setInstituto(newValue);
              }}
              noOptionsText="Sin resultados"
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  size="small"
                  style={{
                    width: "100%",
                    fontFamily: "'Noto Sans JP', sans-serif",
                  }}
                />
              )}
            />
          </Col>

          {instituto && (
            <CrearInstitutoClassicsIndividual
              instituto={instituto}
              clearEdit={() => setEditDone(true)}
            />
          )}
        </Row>
      </Container>
    </>
  );
};

export default EditarInstitutoClassics;
